import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

const PreorderContext = createContext(null);
const KEY = 'tt_preorders';

export const PreorderProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; }
  });
  const [dialogProduct, setDialogProduct] = useState(null);
  const [pendingItem, setPendingItem] = useState(null);

  const setPending = useCallback((product, size, qty = 1) => {
    setPendingItem({ product, size, qty });
  }, []);
  const clearPending = useCallback(() => setPendingItem(null), []);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const reserve = useCallback((product, { email, size, qty = 1 }) => {
    const unitPrice = product.sizePrices?.[size] ?? product.price;
    const entry = {
      id: `${product.id}-${size}-${Date.now()}`,
      productId: product.id,
      productName: product.name,
      image: product.media?.primary_image || product.images?.[0],
      price: unitPrice,
      size,
      qty,
      email,
      reservedAt: new Date().toISOString(),
    };
    setItems((prev) => [entry, ...prev]);
    return entry;
  }, []);

  const remove = useCallback((id) => setItems((prev) => prev.filter((i) => i.id !== id)), []);
  const clear = useCallback(() => setItems([]), []);

  return (
    <PreorderContext.Provider value={{ items, reserve, remove, clear, dialogProduct, setDialogProduct, pendingItem, setPending, clearPending }}>
      {children}
    </PreorderContext.Provider>
  );
};

export const usePreorder = () => {
  const ctx = useContext(PreorderContext);
  if (!ctx) throw new Error('usePreorder must be used within PreorderProvider');
  return ctx;
};
